module.exports = __webpack_public_path__ + "img/17545.85ab8101.jpg";